import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './i18n';
import './App.css';
import HomePage from './pages/HomePage';
import ClientArea from './pages/ClientArea';
import AdminLayout from './pages/admin/AdminLayout';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/"          element={<HomePage />} />
        <Route path="/dashboard" element={<ClientArea />} />
        <Route path="/admin/*"   element={<AdminLayout />} />
      </Routes>
    </Router>
  );
}

export default App;